import React, { useState } from 'react';
import { FaCheckSquare, FaRegSquare, FaInfoCircle } from 'react-icons/fa';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const CheckBox = ({ onChange, initialChecked, text, error, hoverText, disabled, bigCheck, isHtml }) => {
    const [checked, setChecked] = useState(initialChecked || false);

    const toggleCheckbox = () => {
        if (!disabled) {
            setChecked(!checked);
            onChange && onChange(!checked);
        }
    };

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            {hoverText}
        </Tooltip>
    );

    return (
        <div className={`form-card-checkbox-container mt-4 ${disabled ? 'form-card-checkbox-disabled' : ''}`} onClick={toggleCheckbox}>
            {checked ? (
                <FaCheckSquare size={20} className={`form-card-checkbox-checked ${bigCheck ? 'big-check' : null}`} />
            ) : (
                <FaRegSquare size={20} className={`form-card-checkbox ${bigCheck ? 'big-check' : null}`} />
            )}

            {hoverText ? (
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={renderTooltip}
                >
                    <span>
                        {isHtml ? (
                            <span dangerouslySetInnerHTML={{ __html: text }} />
                        ) : (
                            <span>{text}</span>
                        )}
                        <span>
                            <FaInfoCircle size={12} className='form-card-checkbox-info' />
                        </span>
                    </span>
                </OverlayTrigger>
            ) : (
                <>
                    {isHtml ? (
                        <span
                            className={`form-card-checkbox-text ${error ? 'form-card-checkbox-error' : ''}`}
                            dangerouslySetInnerHTML={{ __html: text }}
                        />
                    ) : (
                        <span className={error ? 'form-card-checkbox-error' : null}>
                            {text}
                        </span>
                    )}
                </>
            )}
        </div>
    );
};

export default CheckBox;
